import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '@/components/sections/ImageBanner.scss';

interface ImageBannerProps {
  city?: string;
  image: string;
  path?: string;
  label?: string;
}

const ImageBanner: React.FC<ImageBannerProps> = ({ city, image, path }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      className={`image-banner ${path ? 'image-banner--is-link' : ''}`}
      {...(path && { onClick: () => navigate(path) })}
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.3 }}
    >
      <motion.div
        className="image-banner__curtain"
        variants={{
          initial: { scaleX: 1 },
          animate: { scaleX: 0, transition: { duration: 1, ease: [0.22, 1, 0.36, 1] } },
        }}
      />
      <div className="image-banner__bg">
        <img src={image} alt={city ?? image.toString()} className="image-banner__img" />
        <div className="image-banner__scrim" />
      </div>
      <div className="image-banner__content">
        {city && (
          <div className="image-banner__text-wrap">
            <motion.h2
              className="image-banner__title"
              variants={{
                initial: { y: 40, opacity: 0 },
                animate: { y: 0, opacity: 1, transition: { delay: 0.4, duration: 0.8 } },
              }}
            >
              {city}
            </motion.h2>
            <motion.div
              className="image-banner__line"
              variants={{
                initial: { scaleX: 0 },
                animate: { scaleX: 1, transition: { delay: 0.6, duration: 1 } },
              }}
            />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ImageBanner;
